import { formatWatchTime } from "@/Helpers/formatWatchTime";
import { MovieBlockProps } from "@/types/components/MovieBlockProps";
import { CategorySeriesModel } from "@/types/models/CategorySeriesModel";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "@inertiajs/react";
import { useEffect, useState } from "react";

const PatientMovieBlock = ({ image, title, timeLeft, timeSummary = '', link, model, type = 'Video', is_pin_protected = false }: MovieBlockProps) => {
    const resolveExtension = (file: string): string => {
        return file.replace(/(\/images\/[^.]+)\.[a-z]+/i, "$1.webp");
    }

    return (
        <div className="movie-card">
            <div className="relative w-full pb-[56.25%] aspect-video">
                <Link href={link} title={title} className="h-full w-full absolute inset-0 bg-cover bg-no-repeat rounded-lg z-[1]" style={{ backgroundImage: `url(${resolveExtension(image)})` }}></Link>
            </div>
            <div className="maxMd:block hidden mt-2">
                <div className="flex">
                    <p className="h5 text-arcticMist font-semibold tracking-[0.36px]">{title}</p>
                </div>
                {timeSummary !== '' &&
                    <p className="text-body text-accordorange tracking-[0.24px]">Czas oglądania: {formatWatchTime(timeSummary)}</p>
                }
            </div>
            <div className="my-2 flex justify-between maxMd:hidden">
                <div className="flex items-center gap-x-2 justify-between w-full">
                    <div className="w-[calc(100%-48px)]">
                        <p className="h5 text-arcticMist font-semibold tracking-[0.36px]">{title}</p>
                        {timeSummary !== '' &&
                            <p className="text-body text-accordorange tracking-[0.24px]">Czas oglądania: {formatWatchTime(timeSummary)}</p>
                        }
                    </div>
                    {!!is_pin_protected && <div className="size-10 bg-accordorange rounded-full flex items-center justify-center"><Icon icon={`ph:lock-key`} className="text-arcticMist origin-bottom animate-lock-wiggle-loop" width={24} /></div>}
                </div>
            </div>
        </div>
    )
}

export default PatientMovieBlock;
